import React from "react";

// import {
//   Icon,
//   //Button,
// } from "semantic-ui-react";

const WhyChooseUs = () => {
  //*************** */
  return (
    <section className="padding-gr-outer bgColor-gr1 ">
      
          <div className="inner-gr bgColor-gr1 ">
            <div className="headtitl">
              <div
                className="font-36B color-CornflowerBlue px-20"
              >
                Why <span>Choose Us?</span>
              </div>
              <p className="font-18B px-20">
                We provide full service at every step.
              </p>
              <div className="devider">
               
              </div>
            </div>

            <div className="flex-center direction-r2c">
              <div className="card-why">
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <img src="/why1.png" alt="why1 " />
                </div>
                <div>
                  <h4 className="textAlign-center">Trusted By Thousands</h4>
                  <p>
                    We are one of the oldest real estate company in Dwarka and
                    Dwarka Expressway and have served Thousands of customers.
                  </p>
                </div>
              </div>
              <div className="card-why">
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <img src="/why2.png" alt="why1 " />
                </div>
                <div className="textchoose">
                  <h4 className="textAlign-center">One Stop Solution</h4>
                  <p>
                    We provide all real estate related services such as
                    Documentation, Bank Loan, TDS /Tax Compliances, Registration
                    of Property, Interiors, Vastu,etc so our customers don't
                    have to bother themselves for anything related to there
                    home.{" "}
                  </p>
                </div>
              </div>
              <div className="card-why">
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <img src="/why3.png" alt="why1 " />
                </div>
                <div className="textchoose">
                  <h4 className="textAlign-center">Loans Made Easy</h4>
                  <p>
                    We are associated with multiple Public / Private Sector
                    banks such as SBI, Bank of Baroda, HDFC, ICICI, Axis, etc
                    for your finance needs and get all the work done from your
                    door step.{" "}
                  </p>
                </div>
              </div>

              <div className="card-why">
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <img src="/why4.png" alt="why1 " />
                </div>
                <div className="textchoose">
                  <h4 className="textAlign-center">Interiors Fascinate You</h4>
                  <p>
                    We have a In-House team of interior designer and
                    professionals to take care of your interior &amp; renovation
                    needs of your dream home. Whatever Work &amp; Designs you
                    chose we promise to deliver in time framed manner and best
                    of the quality.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
       
    </section>
  );
};

export default WhyChooseUs;
